/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestFiltersCto } from '../../models/test-filters-cto';

export interface GetTestFilters$Plain$Params {
}

export function getTestFilters$Plain(http: HttpClient, rootUrl: string, params?: GetTestFilters$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestFiltersCto>> {
  const rb = new RequestBuilder(rootUrl, getTestFilters$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestFiltersCto>;
    })
  );
}

getTestFilters$Plain.PATH = '/automatedtest/v1/cicd/filters';
